import React, { useMemo } from 'react'
import LogoLoop from './LogoLoop'
import './css/LogoLoopSection.css'

const PROVIDERS = [
  {
    id: 'expressgate',
    logo: '/img/Logo1.png',
    name: 'ExpressGate',
    focus: 'Entregas urgentes, última milla',
    tagline: 'Cobertura 24/7 con SLA garantizado',
    gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
  },
  {
    id: 'rapidmove',
    logo: '/img/Logo2.png',
    name: 'Rapidmove',
    focus: 'Carga ligera y paquetería',
    tagline: 'Rastreo minuto a minuto en la app',
    gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)'
  },
  {
    id: 'securemile',
    logo: '/img/Logo3.png',
    name: 'Securemile',
    focus: 'Transporte asegurado premium',
    tagline: 'Auditorías trimestrales y monitoreo activo',
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
  },
  {
    id: 'translogix',
    logo: '/img/Logo4.png',
    name: 'Translogix',
    focus: 'Logística internacional',
    tagline: 'Despacho aduanal y rutas multimodales',
    gradient: 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)'
  },
  {
    id: 'suretrack',
    logo: '/img/Logo5.png',
    name: 'Suretrack',
    focus: 'Monitoreo y telemetría',
    tagline: 'Sensores IoT y alertas predictivas',
    gradient: 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)'
  }
]

export default function LogoLoopSection() {
  const providers = useMemo(() => PROVIDERS, [])
  const loopItems = useMemo(
    () =>
      providers.map(provider => ({
        node: <PartnerCard key={provider.id} provider={provider} />
      })),
    [providers]
  )

  return (
    <section className="section partners-section" aria-label="Operadores destacados en Flotte">
      <div className="partners-section__inner">
        <header className="partners-header">
          <span className="partners-header__badge">Operadores integrados</span>
          <h2>Transportistas verificados listos para cotizar</h2>
          <p>
            Seleccionamos a los aliados con mejores indicadores de cumplimiento, cobertura y experiencia.
            Descubre con quién puedes mover tu carga hoy mismo.
          </p>
        </header>

        <LogoLoop
          logos={loopItems}
          speed={18}
          direction="left"
          gap={40}
          pauseOnHover
          scaleOnHover={false}
          fadeOut
          fadeOutColor="rgba(246, 250, 255, 1)"
          ariaLabel="Transportistas verificados destacados"
          width="100%"
        />
      </div>
    </section>
  )
}

function PartnerCard({ provider }) {
  return (
    <article
      className="partner-card"
      style={{ '--partner-gradient': provider.gradient }}
      tabIndex={0}
    >
      <div className="partner-card__banner" aria-hidden="true" />
      <div className="partner-card__body">
        <div className="partner-card__avatar">
          <img src={provider.logo} alt={provider.name} loading="lazy" decoding="async" />
        </div>
        <h3>{provider.name}</h3>
        <p className="partner-card__focus">{provider.focus}</p>
        <p className="partner-card__tagline">{provider.tagline}</p>
        <div className="partner-card__footer">
          <span className="partner-card__badge">Operador verificado</span>
          <button type="button" className="partner-card__cta">
            Ver perfil
          </button>
        </div>
      </div>
    </article>
  )
}
